import { createContext } from "react";

export type Account = {
  id: string;
  companyName: string;
  iamId: string;
  primary: boolean;
};

export type AccountProviderContext = {
  accounts: Account[];
  accountsLoading: boolean;
  account: Account;
  /** Value for `/:accountId` in in-app routes; CDH or IAM id depending on config. */
  accountRouteId: string;
  setAccount: (routeAccountId: string) => void;
  getAccountPath: (routeAccountId: string) => string;
  getAccountDashboardPath: (routeAccountId: string) => string;
};

export const AccountContext = createContext<AccountProviderContext | undefined>(
  undefined
);
